<div class="navigation-menu" *ngIf="showTemplate">
    <i class="hm-icon-close top-x" (click)="hide()"></i>
    <div class="navigation-selection">
        <ng-container *ngFor="let reportItem of reportItems">
            <a *ngIf="!restrictReportNavigationItem(reportItem.id)" [class.disabled]="reportItem.isDisabled" (click)="navigate(reportItem.id)">
                <i class="fas fa-chevron-right"></i> {{reportItem.title}}
            </a>
        </ng-container>
    </div>
</div>